export const CAR_PRIZE_DRAW_URL = '/car-prize-draw';
